var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6293_2506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1114 9.58606C11.6636 9.48973 11.3093 9.69763 10.9957 9.8792C10.6744 10.0663 10.0636 10.5618 9.71347 10.435C7.92088 9.69694 6.23492 8.12794 5.50509 6.32817C5.37646 5.97057 5.86966 5.35586 6.05538 5.03083C6.2356 4.7162 6.43921 4.35861 6.34635 3.90745C6.26243 3.50203 5.17697 2.12084 4.79314 1.74315C4.54001 1.49366 4.28068 1.35644 4.01448 1.33427C3.01363 1.2913 1.89584 2.62675 1.6998 2.94623C1.20866 3.62747 1.21141 4.53394 1.70805 5.63307C2.90494 8.58533 7.43181 13.0408 10.3951 14.2827C10.942 14.5384 11.4421 14.6666 11.8913 14.6666C12.3308 14.6666 12.7222 14.5439 13.0586 14.3007C13.3124 14.1544 14.7026 12.9812 14.6661 11.9534C14.6441 11.6915 14.5072 11.4295 14.261 11.1758C13.8861 10.7884 12.5138 9.6706 12.1114 9.58606Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6293_2506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.3b722c1f57c4a817aec936d3c587a8f8.svg";
export { ForwardRef as ReactComponent };